import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
	LookupInput,
	DistrictSelector,
} from '@components';

export const Home: React.FC = () => {
	const navigate = useNavigate();

	const customClass = {
		HeaddingLink:
			'text-[#FFFFFF] underline hover:text-[#01315a] cursor-pointer',
	};

	const navigateToProperty = () => {
		navigate('./property');
	};

	const navigatationHandler = (val: string) => {
		navigate(val);
	};

	return (
		<div className="w-full black-text  mx-auto  text-center pt-6">
			<h1 className=" text-2xl font-medium text-[24px] mb-4">
				Welcome to the NYAA PROPERTY PORTAL!
			</h1>

			<div className="mx-auto  mt-16 w-full md:w-[45%]">
				<div className="mb-6 mx-5">
					<p className="block font-medium   mb-6">
						Enter an address to find information about a building:
					</p>
					<div className="w-full md:w-[90%] mx-auto ">
						<LookupInput navigaterFunction={navigateToProperty} />
					</div>
				</div>
				<span className="px-4 font-semibold   mb-6 ">OR</span>
				<div className="mb-6 mt-6 mx-5">
					<p className="block font-medium   mb-6">
						View data about a district or zip code:
					</p>
					<div className=" grid justify-center w-full">
						<DistrictSelector />
					</div>
				</div>

				{/* Custom Search */}
				<div className="text-center">
					<span className="">
						You can also{' '}
						<span
							onClick={navigatationHandler.bind(this, '/search')}
							className="text-link"
						>
							create a Custom Search
						</span>
					</span>
				</div>
			</div>
			{/* <div className=" mx-auto text-[16px]  mt-16 w-full text-left space-y-4 bg-[hsla(212.73,35.48%,30.39%,1)] p-12 text-light mb-0 md:w-[80%] leading-relaxed">
				<h1 className="text-[26px] font-bold mb-4">ABOUT</h1>
				<p>
					The NYAA Alert Project (NYAA) Portal is a dynamic and powerful
					data tool that helps you understand a New York City neighborhood’s
					housing landscape, where tenants and homeowners are at heightened risk
					of NYAA, and what is happening in buildings where tenants or
					homeowners are having problems.
				</p>
				<p>NYAA Property Portal is made up of three features:</p>
				<p>
					The{' '}
					<b
						className={`${customClass.HeaddingLink}`}
						onClick={navigatationHandler.bind(this, '/lookup')}
					>
						Property Lookup
					</b>{' '}
					Property Lookup lets you investigate NYAA threats at a
					building level, view detailed records over time, find patterns and
					connections, and get the most recent information possible.
				</p>
				<p>
					The{' '}
					<b
						className={`${customClass.HeaddingLink}`}
						onClick={navigatationHandler.bind(this, '/district-dashboard')}
					>
						District Dashboard{' '}
					</b>{' '}
					allows you to apply NYAA threat indicators across districts or
					zip codes to see a broader snapshot of threats by neighborhood, and
					produce maps and lists of buildings that might not be on your radar
					for outreach and organizing.
				</p>

				<p>
					The{' '}
					<b
						className={`${customClass.HeaddingLink}`}
						onClick={navigatationHandler.bind(this, '/search')}
					>
						Custom Search
					</b>{' '}
					allows you to customize maps and lists of buildings that meet your
					unique search criteria and answer specific research questions about
					the threats facing our neighborhoods.
				</p>

				<p>
					The NYAA Property Portal is made possible by the support of the New
					York City Council and New York State Senate.
				</p>
				<h1 className="text-[26px] font-bold mb-4">
					The NYAA Alert Project
				</h1>
				<p>
					In New York City, ending NYAA is one of the most urgent issues
					we face.The NYAA Alert Project is designed to address this
					problem by providing effective early warning information for residents
					facing harassment and NYAA, for communities being
					destabilized, and for the community groups and policy makers trying to
					address the crisis.
				</p>
				<p>
					Existing data and information is fragmented and often confusing, which
					can make it challenging to identify which buildings are most
					vulnerable in order to intervene.
				</p>
				<p>
					We use data and information visualization tools to proactively
					identify buildings that are facing a rising risk of NYAA. With
					this information community groups, decision makers, and local
					residents themselves can take strategic steps to push back with
					outreach, education, and organizing strategies.
				</p>
				<p>
					The NYAA Alert Project is operated by the{' '}
					<b className={`${customClass.HeaddingLink}`}>
						<a
							href="https://anhd.org/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-[white]"
						>
							Association for Neighborhood and Housing Development (ANHD)
						</a>
					</b>
					.
				</p>
				<p>
					Developed by{' '}
					<b className={`${customClass.HeaddingLink}`}>
						<a
							href="https://blueprintinteractive.com/index.html"
							target="_blank"
							rel="noopener noreferrer"
							className="text-[white]"
						>
							Blueprint Interactive
						</a>
						.
					</b>
				</p>
			</div> */}
		</div>
	);
};